import styled from 'styled-components';

import { colorPalette, colorTokens } from '../../../shared/components/variables';

export const StyledIncidentTable = styled.div`
  && {
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 1.11px 0px 4.42px 0px #00000040;

    .MuiDataGrid-columnHeaders {
      background-color: ${colorPalette.navy990};
      border-bottom: 1px solid ${colorPalette.neutral450};
      min-height: unset !important;
      height: 40px !important;

      .MuiDataGrid-iconSeparator {
        display: none;
      }
    }

    .MuiDataGrid-cell {
      align-items: flex-start;
      padding: 6px;
      max-height: unset !important;
      border: 0 !important;
      white-space: unset !important;
    }

    .MuiDataGrid-columnHeader {
      padding: 0 6px !important;
    }

    .MuiDataGrid-columnHeader,
    .MuiDataGrid-cell {
      &:focus,
      &:focus-within {
        outline: none;
      }
    }

    .MuiDataGrid-columnHeader .MuiIconButton-sizeSmall {
      background: transparent !important;
    }

    .MuiDataGrid-columnHeader:not(.MuiDataGrid-columnHeader--sorted) .MuiDataGrid-sortIcon {
      opacity: 0.5 !important;
      visibility: visible;
    }

    .MuiDataGrid-virtualScrollerContent {
      height: 65vh !important;
    }

    .MuiDataGrid-row {
      cursor: pointer;
      background-color: ${colorPalette.white} !important;
      border-bottom: 1px solid ${colorTokens.border.main} !important;
      max-height: unset !important;

      &.active {
        background-color: ${colorTokens.primary.selected} !important;
      }
    }

    .clamped {
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;
      overflow: hidden;
    }

    .status-cell {
      text-align: center;

      .id {
        color: ${colorTokens.text.secondary};
      }
    }

    .details-cell {
      .classification {
        display: flex;
        align-items: center;

        & > p:first-child {
          margin-right: 6px;
        }
      }
    }

    .account-cell,
    .reportedParty-cell {
      h6 {
        margin: 12px 0;
      }
    }

    .reportedParty-cell {
      h6 {
        margin-top: 8px;
      }
    }

    .MuiDataGrid-cell[data-field='assigned'],
    .MuiDataGrid-cell[data-field='incident_date'],
    .MuiDataGrid-cell[data-field='reported_on'] {
      align-self: center;
      align-items: center;
    }

    .MuiDataGrid-cell[data-field='status'] {
      justify-content: center;
    }
  }
`;

export const EmptyTableContainer = styled.div`
  padding: 20px;
  display: flex;
  justify-content: center;
`;
